module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newDetail"
  }, [_c('div', {
    staticClass: "topcontent"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      医院提醒\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.handledContentTxt)
    }
  }), _vm._v(" "), (_vm.btnShow) ? _c('x-button', {
    staticClass: "orangeBtn",
    attrs: {
      "disabled": _vm.submitdisabled
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.sureTxt))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bottomContent"
  }), _vm._v(" "), _c('alert', {
    staticClass: "newDetailtk",
    attrs: {
      "title": "医院提醒",
      "content": _vm.tkcontentTxt,
      "button-text": "我已知晓"
    },
    on: {
      "on-hide": _vm.tkHide
    },
    model: {
      value: (_vm.tkshow),
      callback: function($$v) {
        _vm.tkshow = $$v
      },
      expression: "tkshow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36c92632","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/newDetailProject/newDetail.vue
// module id = foFM
// module chunks = 7